import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import "../assets/css/condition.css";
const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.2,
        },
    },
};

const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
        y: 0,
        opacity: 1,
    },
};

const ConditionsUtilisationPage = () => {
     const { t } = useTranslation("condition");
    return (
        <motion.div
            className="conditions-utilisation-page" // Utilisation d'une classe CSS spécifique
            initial="hidden"
            animate="visible"
            variants={containerVariants}
        >
            <div className="max-w-4xl mx-auto">
                <h1 className="page-title">{t("title")}</h1>
                <motion.div variants={itemVariants}>
                    <p className="paragraph">{t("introduction")}</p>
                </motion.div>

                <motion.div variants={itemVariants}>
                    <h2 className="section-title">{t("section1.title")}</h2>
                    <ul className="list-disc">
                        <li>{t("section1.point1")}</li>
                        <li>{t("section1.point2")}</li>
                        <li>{t("section1.point3")}</li>
                    </ul>
                </motion.div>

                <motion.div variants={itemVariants}>
                    <h2 className="section-title">{t("section2.title")}</h2>
                    <p className="paragraph">{t("section2.paragraph1")}</p>
                    <p className="paragraph">{t("section2.paragraph2")}</p>
                </motion.div>

                <motion.div variants={itemVariants}>
                    <h2 className="section-title">{t("section3.title")}</h2>
                    <p className="paragraph">{t("section3.paragraph1")}</p>
                </motion.div>
                <motion.div variants={itemVariants}>
                    <h2 className="section-title">{t("section4.title")}</h2>
                    <p className="paragraph">{t("section4.paragraph1")}</p>
                </motion.div>

                <motion.div variants={itemVariants}>
                    <h2 className="section-title">{t("section5.title")}</h2>
                    <p className="paragraph">{t("section5.paragraph1")}</p>
                </motion.div>

                <motion.div variants={itemVariants}>
                    <h2 className="section-title">{t("section6.title")}</h2>
                    <p className="paragraph">{t("section6.paragraph1")}</p>
                </motion.div>
                <motion.div variants={itemVariants}>
                    <h2 className="section-title">{t("section7.title")}</h2>
                    <p className="paragraph">{t("section7.paragraph1")}</p>
                </motion.div>
                <motion.div variants={itemVariants}>
                    <h2 className="section-title">{t("section8.title")}</h2>
                    <p className="paragraph">{t("section8.paragraph1")}</p>
                </motion.div>
                <motion.div variants={itemVariants}>
                    <h2 className="section-title">{t("section9.title")}</h2>
                    <p className="paragraph">{t("section9.paragraph1")}</p>
                </motion.div>
                <motion.div variants={itemVariants}>
                    <h2 className="section-title">{t("section10.title")}</h2>
                    <p className="paragraph">{t("section10.paragraph1")}</p>
                </motion.div>
                <motion.div variants={itemVariants}>
                    <h2 className="section-title">{t("section11.title")}</h2>
                    <p className="paragraph">{t("section11.paragraph1")}</p>
                </motion.div>
                <motion.div variants={itemVariants}>
                    <h2 className="section-title">{t("section12.title")}</h2>
                    <p className="paragraph">{t("section12.paragraph1")}</p>
                </motion.div>
                <motion.div variants={itemVariants}>
                    <h2 className="section-title">{t("section13.title")}</h2>
                    <p className="paragraph">{t("section13.paragraph1")}</p>
                </motion.div>
                <motion.div variants={itemVariants}>
                    <h2 className="section-title">{t("section14.title")}</h2>
                    <p className="paragraph">{t("section14.paragraph1")}</p>
                </motion.div>
                <motion.div variants={itemVariants}>
                    <h2 className="section-title">{t("section15.title")}</h2>
                    <p className="paragraph">{t("section15.paragraph1")}</p>
                </motion.div>
                <motion.div variants={itemVariants}>
                    <h2 className="section-title">{t("section16.title")}</h2>
                    <p className="paragraph">{t("section16.paragraph1")}</p>
                </motion.div>
            </div>
        </motion.div>
    );
};

export default ConditionsUtilisationPage;
